export const content = {
  title: "Our Rates",
  subtitle: "We are passionate about teaching at ANC Academy. That is why we ensure our prices are affordable.",
}